import React, { useState } from 'react';
import { useEffect } from 'react';

export const UnefonFlex = React.memo(({oferta1}) => {
    const [beneficios, setBeneficios] = useState([]);
    
    const [regalos, setRegalos] = useState([]);


    const getBeneficios = () => {
        let beneficiosBaseArray = [];
        
        oferta1.beneficiosBase.map((ofr)=>{
             
               beneficiosBaseArray = [...beneficiosBaseArray, ofr]
        });
        setBeneficios(beneficiosBaseArray);
    }

    const getRegalos = () => {
        let benefociosRegalo = [];
        oferta1.beneficiosOferta.map((ofr)=>{
            benefociosRegalo = [...benefociosRegalo, ofr]
        });
        setRegalos(benefociosRegalo);
    }

    useEffect(() => {
        getBeneficios();
        getRegalos();
        
    }, [])


  return (
    <>
        <div className="contenedorDatos">
            { 
                 beneficios.map((sub, index) =>
                      <div key={index} className="datoMulti">
                        <div className="cantidadM"> {sub.benefitQuantity} {sub.benefitDescription}</div> 
                      </div>
                    )
             }
        </div>

        <div className="contenedorRegalo3">
            { 
                 regalos.map((sub, index) =>
                      <div key={index} className="dataMultiReg">
                        <div className="cantidadM"> {sub.benefitDescription}  </div>
                        <div className="adicional">
                            {
                                (sub.validity.trim().toLowerCase().includes('s'))  ? "Adicionales" : "Adicional"
                            }
                        </div>
                        
                      </div>
                    )
             }
        </div>

    
    </>
  )
}
)

